import { useEffect, useMemo, useState } from "react";


const useGiftCardValidationManager = ({ }: any) => {

  const [formErrors, setFormErrors]   = useState<any>({});

  /**
   * Update the gift card form errors
   * @param {*} newErrors 
   */
  const updateFormErrors = (newErrors: any) => {

    setFormErrors(newErrors);

  };


  /**
   * If there is an error after validation, the first input field with an
   * error will be focused
   */
  useEffect(() => {

    const element = document.querySelector(".gc__input_field_error") as HTMLElement;
    if (element) element.focus();

  }, [formErrors]);

  const res = {
    formErrors,
    updateFormErrors
  }

  return useMemo(() => res, [res]);

}

export default useGiftCardValidationManager;